// @flow

import React, { useEffect } from 'react';
import { BrowserView, MobileView } from 'react-device-detect';
import useSetState from 'core/hooks/useSetState';
import BtnXs from 'components/BtnXs';
import BtnExtended from 'components/BtnExtended';

import { jobs as t } from 'helpers/translation';
import { links } from 'core/config';

type Props = {
  userId: number | string,
  search: any,
  addJobAlert: Function,
  jobAlertErrors: Array<any>,
  toggleVisibility: Function,
  showInput: boolean
};

type StateProps = {
  value: string | number,
  errors: Array<any>,
  jobAlertSaved: boolean,
  showInput: boolean
};

export default ({ userId, search, addJobAlert, jobAlertErrors, toggleVisibility, showInput: showAlertInput }: Props) => {
  const [{ value, errors, jobAlertSaved, showInput }, setState] = useSetState<StateProps>({
    value: '',
    errors: [],
    jobAlertSaved: false,
    showInput: showAlertInput
  });

  useEffect(() => {
    setState({ value: '', errors: jobAlertErrors });
  }, [jobAlertErrors]);

  useEffect(() => {
    setState({ showInput: showAlertInput, jobAlertSaved: false });
  }, [showAlertInput]);

  const jobAlertParams = () => {
    const { q, category_ids, industry_ids, work_type_ids, place_id, distance,
      entry_level_ids, job_language_ids, number_employees_group_ids, region_ids
    } = search;

    const params = {
      enabled: true,
      keywords: q ? q.replace(/[,.+]/g,' ') : '',
      name: value,
      regions: region_ids ? region_ids.map(id => ({ id })): [],
      categories: category_ids ? category_ids.map(id => ({ id })) : [],
      industries: industry_ids ? industry_ids.map(id => ({ id })) : [],
      work_types: work_type_ids ? work_type_ids.map(id => ({ id })) : [],
      entry_levels: entry_level_ids ? entry_level_ids.map(id => ({ id })) : [],
      job_languages: job_language_ids ? job_language_ids.map(id => ({ id })) : [],
      number_employees_groups: number_employees_group_ids ? number_employees_group_ids.map(id => ({ id })) : [],
      place: place_id ? { id: place_id.toString() } : {},
      distance: place_id ? +(distance || 5) : null,
      user: { id: userId }
    };

    return params;
  };

  const handleSave = () => {
    if (value.length > 0) {
      addJobAlert(showInputCallback => {
        setState({ value: '', showInput: showInputCallback, jobAlertSaved: true });
      }, jobAlertParams());
    }
  };

  const handleErrors = () => {
    if (!!errors && showInput && userId) {
      return errors.map(({ title }) => (
        <p key={title} className="jobs-alert__error">{title}</p>
      ));
    }
  };

  const handleShowInput = () => toggleVisibility('input');

  const handleClear = () => {
    setState({ value: '', errors: [] });
    handleShowInput();
  };

  const renderAddJobAlert = () => (
    <>
      {
        showInput
          ? <>
            <input
              className="jobs-alert__input"
              type="text"
              placeholder={t.job_alert.placeholder}
              value={value}
              autoFocus={showInput}
              onChange={e => setState({ value: e.target.value })}
            />
            <MobileView renderWithFragment="true">
              <BtnExtended
                text={t.btn.save_job_alert}
                type="primary"
                handleClick={handleSave}
                classes="btn_extended"
              />
            </MobileView>
            <BrowserView renderWithFragment="true">
              <div className="jobs-alert__buttons">
                <BtnXs
                  text={t.btn.save_job_alert}
                  type="primary"
                  handleClick={handleSave}
                />
                <button
                  type="button"
                  className="jobs-alert__link"
                  onClick={handleClear}
                >{t.btn.later}</button>
              </div>
            </BrowserView>
          </>
          : <BtnXs
            text={t.btn.add_job_alert}
            type="primary"
            handleClick={handleShowInput}
            href={!userId ? links.login : ''}
          />
      }
      {handleErrors()}
    </>
  );

  return (
    <div className="jobs-alert">
      <div className="jobs-alert__title icon-save-search">{t.job_alert.title}</div>
      <p className="jobs-alert__desc">{t.job_alert.desc}</p>
      {
        jobAlertSaved
          ? <BtnXs text="Abonniert" type="secondary" classes="btn_check"/>
          : renderAddJobAlert()
      }
    </div>
  );
};
